import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"; // Import Link from react-router-dom
import {
    Box,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    Typography,
    Grid,
    Autocomplete,
    TextField,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    FormControlLabel,
    Checkbox,
    Card,
    CardHeader,
    CardContent,
    Chip,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip
} from "@mui/material";

import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import BaseWrapper from "../../components/shared/BaseWrapper";
import { getEmailExceptions } from "../API/emailExceptionAPI";
import EditIcon from "@mui/icons-material/Edit";

function ListEmailExceptions() {
    const [error, setError] = useState(null);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false); // State to manage loading
    const navigate = useNavigate();
    const [exceptionList, setExceptionList] = useState([])

    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);
                setError(null);

                const exceptionList = await getEmailExceptions();
                // sort by clientName, then contact, then email
                exceptionList.sort((a, b) => {
                    const nameCompare = a.clientName.localeCompare(b.clientName);
                    if (nameCompare !== 0) return nameCompare;

                    const contactCompare = a.contact.localeCompare(b.contact);
                    if (contactCompare !== 0) return contactCompare;

                    return a.email.localeCompare(b.email);
                });

                setExceptionList(exceptionList);
            } catch (err) {
                setError(err.message);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, []);
    return (
        <BaseWrapper
            titleIcon={<SupervisedUserCircleIcon />}
            title="Client Retention"
            subTitle="List Email Exceptions"
            subTitleRoute="/list-email-exceptions"
            createButtonLabel="Manage Email Exception"
            onClickCreateButton={() => navigate("/manage-email-exception")}
            successMessage={successMessage}
            setSuccessMessage={setSuccessMessage}
            errorMessage={errorMessage}
            setErrorMessage={setErrorMessage}
            isLoading={isLoading}
        >

            {exceptionList.length > 0 && (
                <Card variant="outlined" sx={{ p: 2, mb: 2 }}>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell><b>Client</b></TableCell>
                                    <TableCell><b>Contact</b></TableCell>
                                    <TableCell><b>Email</b></TableCell>
                                    <TableCell><b>Exceptions</b></TableCell>
                                    <TableCell><b>Action</b></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {exceptionList.map((ex, idx) => (
                                    <TableRow key={idx}>
                                        <TableCell>{ex.clientName || ""}</TableCell>
                                        <TableCell>{ex.contact || ""}</TableCell>
                                        <TableCell>{ex.email || ""}</TableCell>
                                        <TableCell
                                            sx={{
                                                maxWidth: 400,
                                                whiteSpace: "normal",
                                                wordBreak: "break-word",
                                            }}
                                        >
                                            {Array.isArray(ex.exceptions) && ex.exceptions.length > 0 && (
                                                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                                                    {ex.exceptions.map((type, i) => (
                                                        <Chip
                                                            key={i}
                                                            label={type.replace(/_/g, " ")}
                                                            variant="outlined"
                                                            size="small"
                                                        />
                                                    ))}
                                                </Box>
                                            )}
                                        </TableCell>
                                        <TableCell>
                                            <Tooltip title="Edit Exception" arrow>
                                                <IconButton
                                                    onClick={() =>
                                                        window.open(
                                                            `/manage-email-exception?clientId=${ex.clientId}`,
                                                            "_blank"
                                                        )
                                                    }
                                                >
                                                    <EditIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Card>
            )}


        </BaseWrapper>
    );

}


export default ListEmailExceptions;